<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
import { onMount, onDestroy } from 'svelte';
import loader from '@beyonk/async-script-loader';
import { freshworksWidgetStore } from './widgetStore';
export let container = undefined;
const freshworksWidgetId = CONFIG.freshworksWidgetId;
let isVisible = false;
function test() {
    if (typeof window !== 'undefined' && !window.fwSettings) {
        window.fwSettings = {
            'widget_id': freshworksWidgetId,
        };
        !function () { if ("function" != typeof window.FreshworksWidget) {
            var n = function () { n.q.push(arguments); };
            n.q = [], window.FreshworksWidget = n;
        } }();
        return false;
    }
    return true;
}
function callback() {
    console.log('Freshworks loaded.');
    freshworksWidgetStore.setLoaded(true);
    if (typeof window !== 'undefined') {
        freshworksWidgetStore.setInstance(window.FreshworksWidget);
    }
}
function init() {
    loader([
        {
            type: 'script',
            url: `https://euc-widget.freshworks.com/widgets/${freshworksWidgetId}.js`
        }
    ], test, callback);
}
onMount(() => {
    if (freshworksWidgetId) {
        if (!$freshworksWidgetStore.isLoaded) {
            init();
        }
        freshworksWidgetStore.show();
    }
});
onDestroy(() => {
    if (freshworksWidgetId) {
        freshworksWidgetStore.hide();
    }
});
freshworksWidgetStore.subscribe(store => {
    if (typeof window !== 'undefined' && window.FreshworksWidget) {
        if (store.instance && store.isVisible) {
            window.FreshworksWidget('show');
        }
        else if (store.instance && !store.isVisible) {
            window.FreshworksWidget('hide');
        }
    }
});
</script>

<BaseAtom _isotope="FreshworksWidgetAtom" {...container}>
</BaseAtom>
